<template>
  <div class="row">
    <div class="col-12">
      <card class="custom-shadow-card-header card-gis-filter" v-if="isIndex()">
        <el-collapse v-model="activeName" @change="handleCollapse">
          <el-collapse-item :title="titleFilter" name="1">
            <div class="row">
              <div class="col-md-auto">
                <label>Pluviómetro *</label>
                <br />
                <el-select
                  placeholder="Selecionar..."
                  id="listRainAccumulators"
                  style="width: 100%"
                  class="select-primary mb-3 shadow-sm"
                  v-model="model.rainAccumulators"
                  filterable
                  clearable
                  multiple
                  collapse-tags
                  @change="
                    selectAllFromSelect(
                      'model.rainAccumulators',
                      listRainAccumulators
                    ),
                      changeByInterval()
                  "
                >
                  <el-option
                    v-for="option in this.concatAll(listRainAccumulators)"
                    class="select-primary selected-all"
                    :value="option.id"
                    :label="option.name"
                    :key="option.id"
                  ></el-option>
                </el-select>
              </div>
              <div class="col-md-auto">
                <label>Intensidad de Lluvia *</label>
                <br />
                <el-select
                  placeholder="Selecionar..."
                  id="listRainIntensity"
                  style="width: 100%"
                  class="select-primary mb-3 shadow-sm"
                  v-model="model.rainIntensity"
                  filterable
                  clearable
                  multiple
                  collapse-tags
                  @change="
                    selectAllFromSelect(
                      'model.rainIntensity',
                      listRainIntensity
                    ),
                      changeByInterval()
                  "
                >
                  <el-option
                    v-for="option in this.concatAll(listRainIntensity)"
                    class="select-primary selected-all"
                    :value="option.id"
                    :label="option.name"
                    :key="option.id"
                  ></el-option>
                </el-select>
              </div>
              <div class="col-md-auto">
                <label>{{ $t('common_words.analyze_by') }}</label>
                <br />
                <el-select
                  @change="changeByInterval()"
                  filterable
                  @clear="model.bySel = null"
                  class="select-primary custom-width-select mb-3 required-year shadow-sm"
                  size="large"
                  v-model="model.bySel"
                  :placeholder="`${$t('common_words.select')}...`"
                >
                  <el-option
                    v-for="option in Object.values(optionsInterval)"
                    class="select-primary"
                    :value="option.value"
                    :label="option.label"
                    :key="option.value"
                  ></el-option>
                </el-select>
              </div>
              <div
                class="col-12 col-sm-8 col-md-4 col-lg-4 col-xl-3"
                v-if="model.bySel != 'week' && model.bySel != 'year'"
              >
                <label>{{ $t('common_words.calendar') }}</label>
                <br />
                <el-date-picker
                  v-if="renderComponent"
                  v-model="model.rangeDate"
                  class="shadow-sm required-year"
                  v-bind:type="typedatepicket"
                  range-separator="-"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  :picker-options="pickerOptions"
                  :placeholder="`${$t('common_words.select2')}...`"
                  :start-placeholder="$t('common_words.initial_date')"
                  :end-placeholder="$t('common_words.final_date')"
                  @change="changeByInterval()"
                ></el-date-picker>
              </div>
              <div
                class="col-md-auto"
                v-if="model.bySel == 'week' || model.bySel == 'year'"
              >
                <label>Año Inicial</label>
                <br />
                <el-select
                  id="year_sel_init"
                  filterable
                  class="select-primary custom-width-select mb-3 required-year shadow-sm"
                  size="large"
                  v-model="model.year_sel_init"
                  @change="changeByInterval()"
                >
                  <el-option
                    v-for="(option, index) in Object.keys(listYears).reverse()"
                    class="select-primary"
                    :value="option"
                    :label="option"
                    :key="index"
                  ></el-option>
                </el-select>
              </div>
              <div class="col-md-auto" v-if="model.bySel == 'week'">
                <label>Semana Inicial</label>
                <br />
                <el-select
                  filterable
                  class="select-primary custom-width-select mb-3 required-week shadow-sm"
                  size="large"
                  v-model="model.week_sel_init"
                  @change="changeByInterval()"
                >
                  <el-option
                    v-for="(week, index) in listYears[model.year_sel_init]"
                    class="select-primary"
                    :value="week"
                    :label="week"
                    :key="index"
                  ></el-option>
                </el-select>
              </div>
              <div
                class="col-md-auto"
                v-if="model.bySel == 'week' || model.bySel == 'year'"
              >
                <label>Año Final</label>
                <br />
                <el-select
                  id="year_sel_end"
                  filterable
                  class="select-primary custom-width-select mb-3 required-year shadow-sm"
                  size="large"
                  v-model="model.year_sel_end"
                  @change="changeByInterval()"
                >
                  <el-option
                    v-for="(option, index) in Object.keys(listYears).reverse()"
                    class="select-primary"
                    :value="option"
                    :label="option"
                    :key="index"
                  ></el-option>
                </el-select>
              </div>
              <div class="col-md-auto" v-if="model.bySel == 'week'">
                <label>Semana Final</label>
                <br />
                <el-select
                  filterable
                  class="select-primary custom-width-select mb-3 required-week shadow-sm"
                  size="large"
                  v-model="model.week_sel_end"
                  @change="changeByInterval()"
                >
                  <el-option
                    v-for="(week, index) in listYears[model.year_sel_end]"
                    class="select-primary"
                    :value="week"
                    :label="week"
                    :key="index"
                  ></el-option>
                </el-select>
              </div>
              <div class="col-12 col-md-4 col-xl-2">
                <label class="label-primary" style="color: transparent">
                  {{ $t('common_words.filter') }}
                </label>
                <br />
                <l-button
                  wide
                  type="info"
                  class="btn-filter"
                  @click="validate"
                  >{{ $t('common_words.filter') }}</l-button
                >
              </div>
            </div>
          </el-collapse-item>
        </el-collapse>
        <br />
        <div v-if="isIndex()">
          <div v-if="showReport">
            <card-header
              :propPagination="pagination"
              @searchedQuery="searchedQuery"
              class="mr-3 mt-3"
            ></card-header>
            <div class="col-sm-12">
              <el-table
                stripe
                :default-sort="{ prop: 'fieldDate', order: 'descending' }"
                :data="queriedData"
                style="width: 100%"
                :border="true"
                max-height="500"
              >
                <el-table-column
                  v-for="(column, index) in tableColumns"
                  :key="index"
                  :prop="column.prop"
                  :label="column.label"
                  :align="column.align"
                  :sortable="true"
                  :min-width="column.minWidth"
                  :fixed="column.fixed"
                  :resizable="false"
                ></el-table-column>
              </el-table>
            </div>
            <div
              slot="footer"
              class="my-3 col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
            >
              <div class>
                <p class="card-category">
                  {{ $t('table2.showing') }} {{ from + 1 }}
                  {{ $t('table2.a') }} {{ to }} {{ $t('table2.of') }}
                  {{ total }} {{ $t('table2.entries') }}
                </p>
              </div>
              <l-pagination
                class="pagination-no-border"
                v-model="pagination.currentPage"
                :per-page="pagination.perPage"
                :total="pagination.total"
                pageFirst="false"
                pageLast="false"
              ></l-pagination>
            </div>
            <export-tables
              :pdf="{
                filename: `${$t('common_words.rain_report')}.pdf`,
                route: 'devices/reportrainaccumulators/pdf',
                paramMethod: 'POST',
                plusData: {
                  tableColumns: tableColumns,
                  tableData: tableData,
                },
              }"
              :xls="{
                filename: `${$t('common_words.rain_report')}.xlsx`,
                route: 'devices/reportrainaccumulators/excel',
              }"
            />
            <hr />
            <highcharts :options="chartOptions"></highcharts>
            <hr />
            <div style="padding-left: 20px">
              <div class="d-flex flex-wrap">
                <div class="legend-item-rain-accumulator">
                  <span
                    class="color-circle-rain-accumulator"
                    style="background-color: #add8e6"
                  ></span>
                  <span>Lluvia Nula o Muy Leve</span>
                </div>
                <div class="legend-item-rain-accumulator">
                  <span
                    class="color-circle-rain-accumulator"
                    style="background-color: #87ceeb"
                  ></span>
                  <span>Lluvia Leve</span>
                </div>
                <div class="legend-item-rain-accumulator">
                  <span
                    class="color-circle-rain-accumulator"
                    style="background-color: #4682b4"
                  ></span>
                  <span>Lluvia Moderada</span>
                </div>
                <div class="legend-item-rain-accumulator">
                  <span
                    class="color-circle-rain-accumulator"
                    style="background-color: #1e3a5f"
                  ></span>
                  <span>Lluvia Intensa</span>
                </div>
              </div>
            </div>
            <hr />
            <div class="col-12">
              <div class="row">
                <div class="col-12 map-climate">
                  <div
                    ref="map"
                    class="map"
                    v-if="renderComponent"
                    style="height: 800px"
                  ></div>
                  <div
                    id="toolbarDiv"
                    class="esri-component esri-widget"
                    v-if="renderComponent"
                  >
                    <button
                      id="distance"
                      class="action-button esri-widget--button esri-interactive esri-icon-measure-line"
                      style="margin-bottom: 10px"
                      :title="$t('common_words.distance_measurement_tool')"
                    ></button>
                    <button
                      id="area"
                      class="action-button esri-widget--button esri-interactive esri-icon-measure-area"
                      style="margin-bottom: 10px"
                      :title="$t('common_words.area_measurement_tool')"
                    ></button>
                    <button
                      id="clear"
                      class="action-button esri-widget--button esri-interactive esri-icon-trash"
                      style="margin-bottom: 10px"
                      :title="$t('common_words.clear_measurement')"
                    ></button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <not-index-permissions v-else />
      </card>
      <div v-else>
        <br />
        <h5 class="text-muted text-center">
          {{ $t('common_words.no_permissions') }}
        </h5>
      </div>
    </div>
  </div>
</template>
<script>
import { Pagination as LPagination } from 'src/components/index';
import Tables from 'src/class/Tables';
import MixinPermissions from 'src/util/mixinPermissions';
import mixinMasters from 'src/util/mixinMasters';
import MixinMenu from 'src/util/mixinMenu';
import MixinForm from 'src/mixins/forms/mixin-form';
import MixinDatePicker from 'src/util/mixinDatePicker';
import store from '@/store';
import Fuse from 'fuse.js';
import { Axios } from 'src/class/Axios.js';
import SweetAlert from 'src/class/Alerts';
import i18n from 'src/i18n';

import { Chart } from 'highcharts-vue';
import MixinCharts from 'src/util/mixinCharts';
import Highcharts from 'highcharts';
import exportingInit from 'highcharts/modules/exporting';

import MixinArcgisMap from 'src/util/mixinArcgisMap';
import mixinLocation from 'src/util/mixinLocation';

import paginationData from './paginationData';

exportingInit(Highcharts);

export default {
  components: {
    LPagination,
    highcharts: Chart,
  },
  computed: {
    ...Tables.search,
    ...paginationData.functions,
  },
  mixins: [
    mixinMasters,
    MixinPermissions,
    MixinMenu,
    MixinDatePicker,
    MixinForm,
    MixinCharts,
    MixinArcgisMap,
    mixinLocation,
  ],
  data() {
    return {
      model: {
        bySel: 'week',
        year_sel_init: null,
        week_sel_init: 1,
        year_sel_end: null,
        week_sel_end: 1,
        rainAccumulators: [],
        rainIntensity: [1, 2, 3, 4],
        rangeDate: [
          new Date(new Date().getFullYear(), new Date().getMonth(), 1),
          new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0),
        ],
      },
      activeName: '1',
      showReport: false,
      pagination: {},
      searchQuery: '',
      typedatepicket: 'daterange',
      listRainAccumulators: [],
      listYears: [],
      tableData: [],
      tableColumns: [],
      listRainIntensity: [
        { id: 1, name: 'Lluvia Nula o Muy Leve' },
        { id: 2, name: 'Lluvia Leve' },
        { id: 3, name: 'Lluvia Moderada' },
        { id: 4, name: 'Lluvia Intensa' },
      ],
      chartOptions: {},
      center: {
        lat: 37.774546,
        lng: -122.433523,
      },
      rainAccumulators: [],
      mapData: {},
      map: null,
      renderComponent: true,
      pagination: paginationData.pagination,
    };
  },
  watch: {
    '$i18n.locale': 'loadMap',
  },
  computed: {
    titleFilter() {
      if (this.valueCollapse) {
        return this.valueCollapse.length === 1
          ? this.$i18n.t('uti.mixinFilter.hideFilters')
          : this.$i18n.t('uti.mixinFilter.showFilters');
      }
      return this.$i18n.t('uti.mixinFilter.hideFilters');
    },
    optionsInterval() {
      return {
        0: { label: this.$i18n.t('common_words.day'), value: 'daterange' },
        1: { label: this.$i18n.t('common_words.week'), value: 'week' },
        2: { label: this.$i18n.t('common_words.month'), value: 'monthrange' },
        3: { label: this.$i18n.t('common_words.year'), value: 'year' },
      };
    },
    getLabelInterval() {
      try {
        return Object.values(this.optionsInterval).find(
          (option) => option.value === this.model.bySel
        ).label;
      } catch (error) {
        return this.$i18n.t('common_words.interval');
      }
    },
  },
  methods: {
    handleCollapse(val) {
      this.valueCollapse = val;
    },
    changeByInterval() {
      this.showReport = false;
      this.typedatepicket = this.model.bySel;
    },
    async validate() {
      return this.$validator.validateAll().then((isValid) => {
        if (this.model.rainAccumulators.length == 0) {
          let sel = document.getElementById('listRainAccumulators');
          sel.focus();
          sel.classList.add('custom-has-error');
          store.dispatch('utils/removeHasError', sel);
          return false;
        }
        if (this.model.rainIntensity.length == 0) {
          let sel = document.getElementById('listRainIntensity');
          sel.focus();
          sel.classList.add('custom-has-error');
          store.dispatch('utils/removeHasError', sel);
          return false;
        }
        if (!this.model.year_sel_init) {
          let sel = document.getElementById('year_sel_init');
          sel.focus();
          sel.classList.add('custom-has-error');
          store.dispatch('utils/removeHasError', sel);
          return false;
        }
        if (!this.model.year_sel_end) {
          let sel = document.getElementById('year_sel_end');
          sel.focus();
          sel.classList.add('custom-has-error');
          store.dispatch('utils/removeHasError', sel);
          return false;
        }
        if (isValid) this.getData();
      });
    },
    getData() {
      this.showReport = false;
      this.showHideLoading(true);
      let param = {
        route: 'devices/reportrainaccumulators/getreportinfo',
        model: this.model,
      };
      Axios.postMasters(param)
        .then((response) => {
          let responseData = response.data.data;
          this.tableColumns = responseData.tableColumns;
          this.tableData = responseData.tableData;
          this.chartOptions = responseData.graphData;
          this.rainAccumulators = responseData.mapData;
          this.fuseSearch = new Fuse(this.tableData, {
            useExtendedSearch: true,
            threshold: 0.3,
            keys: this.tableColumns.map((prop) => {
              return prop.prop;
            }),
          });
          setTimeout(() => {
            this.loadMap();
          }, 100);
          if (this.tableData.length == 0)
            SweetAlert.warning(i18n.t('common_words.unavailable_data'));
          else this.showReport = true;
          this.showHideLoading();
        })
        .catch((error) => {
          this.showHideLoading();
          this.showMessageErrors(error);
        });
    },
    async loadMap() {
      await this.getPosition();
      this.renderComponent = false;
      this.$emit('showHideLoading', true);
      this.$nextTick(() => {
        this.renderComponent = true;
        this.loadPointMap(null, this.rainAccumulators, 7, {
          lat: this.center.lat,
          lng: this.center.lng,
        });
        this.$emit('showHideLoading');
        setTimeout(() => {
          document.getElementById('toolbarDiv').style = 'top: 13%;right: 30px;';
        }, 10);
      });
    },
  },
  created() {
    this.showHideLoading(true);
    Axios.getMasters('devices/reportrainaccumulators/getselectinfo')
      .then((response) => {
        let responseData = response.data;
        this.listYears = responseData.listYears;
        this.model.year_sel_init = Object.keys(this.listYears).reverse()[0];
        this.model.year_sel_end = Object.keys(this.listYears).reverse()[0];
        this.listRainAccumulators = responseData.listRainAccumulators;
        if (this.listRainAccumulators.length > 0)
          this.model.rainAccumulators = responseData.listRainAccumulatorIds;
        this.showHideLoading();
      })
      .catch((error) => {
        this.showHideLoading();
        this.showMessageErrors(error);
      });
  },
  mounted() {
    this.selectedItemOnMenu('climates');
  },
  destroyed() {
    this.deselectedItemOnMenu('climates');
  },
};
</script>
<style>
.color-circle-rain-accumulator {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  display: inline-block;
  margin-right: 10px;
}
.legend-item-rain-accumulator {
  display: flex;
  margin-right: 20px;
  font-size: 14px;
  font-weight: 400;
  color: #898989;
}
</style>
